export default __webpack_public_path__ + "static/media/gls-de.a57f9a9a.svg";